// frontend/src/components/StaticPageTemplate/index.tsx
import { useEnhancedQuery } from "@uplift-ltd/apollo";
import { useRouter } from "next/router";
import React from "react";
import { PageIdType } from "__generated__/globalTypes";
import ErrorPage from "components/common/ErrorPage";
import { FullPageLoading } from "components/common/Loading";
import { usePageMeta } from "hooks/usePageMeta";
import { StaticPageRenderer } from "./StaticPageContent";
import type {
  StaticPageQueryQuery as StaticPageQuery,
  StaticPageQueryQueryVariables as StaticPageQueryVariables,
} from "./__generated__/queries";
import { STATIC_PAGE_QUERY, USER_PAGE_QUERY } from "./queries";

export { STATIC_PAGE_QUERY, USER_PAGE_QUERY };
export type { StaticPageQuery, StaticPageQueryVariables }; // This is the only necessary change
export type StaticPageParams = { slug: string };

const StaticPageTemplate: React.FC = () => {
  const router = useRouter();
  const slug = Array.isArray(router.query.slug)
    ? router.query.slug.join("/")
    : router.query.slug ?? "";
  const pageSlug = slug ? `/${slug}` : "";

  const { data, loading, error } = useEnhancedQuery<StaticPageQuery, StaticPageQueryVariables>(
    STATIC_PAGE_QUERY,
    {
      variables: { id: pageSlug, idType: PageIdType.URI },
    }
  );

  const page = data?.page;
  usePageMeta(page?.title, page?.seo);

  if (loading) return <FullPageLoading />;
  if (error) return <ErrorPage />;
  if (!page) return <ErrorPage />;

  return <StaticPageRenderer page={page} />;
};

export default StaticPageTemplate;
